import React from "react";
import { Box, Typography } from "@mui/material";
import ArrowButton from "../buttons/arrowButton";

const BannerBox = ({
  title,
  preTitle,
  description,
  image,
  height,
  width,
  align = "left",
  onClick,
}) => {
  const isLeft = align === "left";

  return (
    <Box
      sx={{
        width: width ?? "100%",
        height: height ?? "auto",
        maxWidth: "100%",
        borderRadius: "30px",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignSelf: "stretch",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          transition: "transform .6s ease",
          transformOrigin: "center",
          willChange: "transform",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.36) 0%, rgba(0,0,0,0.10) 60%, rgba(0,0,0,0) 100%)",
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          px: { xs: 3, md: 6 },
          py: { xs: 2.5, md: 4 },
          textAlign: isLeft ? "left" : "right",
          color: "#fff",
        }}
      >
        <Box>
          {preTitle && (
            <Typography
              sx={{
                fontFamily: "'Roboto Condensed', Arial, sans-serif",
                fontWeight: 700,
                letterSpacing: 0,
                mb: 1,
                color: "#FFFFFF",
                fontSize: 14,
                lineHeight: "90%",
              }}
            >
              {preTitle}
            </Typography>
          )}

          <Typography
            component="h3"
            sx={{
              fontFamily: "'Zen Maru Gothic', sans-serif",
              fontWeight: 900,
              fontSize: "36px",
              lineHeight: "110%",
              letterSpacing: 0,
              color: "#F0F0F0",
              mb: 1.5,
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontFamily: "'Roboto Condensed', Arial, sans-serif",
              fontSize: 16,
              fontWeight: 700,
              lineHeight: "120%",
              color: "#FFFFFF",
              mb: 0,
              pr: { md: 10 },
            }}
          >
            {description}
          </Typography>
        </Box>

        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "flex-end",
            width: "100%",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              right: { xs: 16, sm: 20, md: -35 },
              bottom: { xs: 16, sm: 20, md: -15 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 5,
            }}
            onClick={onClick}
          >
            <ArrowButton />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BannerBox;
